import AttributeList from "../../../Components/Pricings/Attributes/AttributeList";

export default function AttributeListing(){
    return(
        <AttributeList/>
    )
}